import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { MonitoringObjectsTable } from './components/index.js';
import {
  getVariables,
  instructionTypeForFilter,
  queryParamsInitial,
  setSearchParamsToState,
} from './store/index.js';

import {
  getFiltersFromSearchParams,
  setFilterParamsToSearchParams,
  setSortParamsToSearchParams,
} from '@/utils';
import { Box } from '@/elements';
import { useLazyQuery } from '@apollo/client';
import { GET_L3_MONITORING_OBJECT } from '@/common/actions/get';
import { SubNavigation } from '@/common/pages/networkProtectionV2/components/SubNavigation/index.jsx';

const MonitoringObjectsView = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [queryParams, setQueryParams] = useState({
    ...queryParamsInitial,
    filters: getFiltersFromSearchParams(Object.fromEntries([...searchParams])),
  });

  const [getDataSettingApi, { data: l3MonitoringObjectsData, loading }] =
    useLazyQuery(GET_L3_MONITORING_OBJECT);

  const onPageChange = (page, size) => {
    searchParams.set('page', String(page));
    searchParams.set('pageSize', String(size));

    setSearchParams(searchParams, { replace: true });
  };

  const onSortingChange = (sortArray) => {
    searchParams.set('page', String(queryParamsInitial.page));

    setSortParamsToSearchParams(sortArray, searchParams);

    setSearchParams(searchParams, { replace: true });
  };

  const onFiltersChange = (filterList) => {
    searchParams.set('page', String(queryParamsInitial.page));

    setFilterParamsToSearchParams(filterList, searchParams);

    setSearchParams(searchParams, { replace: true });
  };

  useEffect(() => {
    setSearchParamsToState(searchParams, setQueryParams, queryParamsInitial);
  }, [searchParams]);

  useEffect(() => {
    let variables = getVariables(queryParams, instructionTypeForFilter);

    getDataSettingApi({
      variables,
    });
  }, [queryParams]);

  return (
    <>
      <Box>
        <SubNavigation />
      </Box>

      <Box direction="column" padding="35px" gap="30px">
        <MonitoringObjectsTable
          loading={loading}
          data={l3MonitoringObjectsData?.l3MonitoringObjects?.items || []}
          onPageChange={onPageChange}
          onSortingChange={onSortingChange}
          onFiltersChange={onFiltersChange}
          queryParams={queryParams}
          totalPages={l3MonitoringObjectsData?.l3MonitoringObjects?.info?.totalPages || 1}
          totalCount={l3MonitoringObjectsData?.l3MonitoringObjects?.info?.totalCount || 0}
        />
      </Box>
    </>
  );
};

export default MonitoringObjectsView;
